// extracted by mini-css-extract-plugin
export default {"cls1":"SplitMobileFab-CloseMenuFab_cls1__HCeJo","cls2":"SplitMobileFab-CloseMenuFab_cls2__c+DFI SplitMobileFab-CloseMenuFab_cls1__HCeJo"};